import React from 'react';
import PropTypes from 'prop-types';

import styles from './TextBox.scss';

const TextBox = (props) => {
	const {
		name,
		type,
		onChange,
		autoComplete,
		placeholder,
		value,
		maxLength,
		className,
		containerClass,
		dataSet,
		hasError,
		error,
		required,
		tabindex,
		onBlur,
		onFocus,
		onKeyDown,
		readonly,
		disabled,
		id,
		customRef,
		defaultValue
	} = props;

	let innerDataSet = {};
	Object.keys(dataSet).map((key) => {
		innerDataSet[`data-${key}`] = dataSet[key];
	});
	let classNameInner = (className === "") ? styles.default : className;
	let contClass = (containerClass === "") ? styles.container : containerClass;
	let hasErrorInner = hasError || error !== '';
	return (
	  <div className={contClass}>
		  <input
			type={type}
			name={name}
			placeholder={placeholder}
			value={value}
			defaultValue={defaultValue}
			onChange={onChange}
			maxLength={maxLength}
			required={required}
			tabIndex={tabindex}
			onBlur={onBlur}
			onFocus={onFocus}
			onKeyDown={onKeyDown}
			readOnly={readonly}
			disabled={disabled}
			id={id}
			ref={customRef}
			autoComplete={autoComplete}
			className={`${classNameInner} ${(hasErrorInner) ? styles.hasError : ''}`}
			{...innerDataSet}
		  />
		  {error !== '' && <div className={styles.error} dangerouslySetInnerHTML={{__html: error}}/>}
	  </div>
	);
}
TextBox.defaultProps = {
	type: 'text',
	className: '',
	hasError: false,
	error: '',
	dataSet: {}
};

TextBox.propTypes = {
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	type: PropTypes.string,
	placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	value: PropTypes.string,
	maxLength: PropTypes.number,
	className: PropTypes.string,
	containerClass: PropTypes.string,
	dataSet: PropTypes.objectOf(PropTypes.string),
	error: PropTypes.string,
	hasError: PropTypes.bool,
	id: PropTypes.string,
	required: PropTypes.bool,
	readonly: PropTypes.bool,
	disabled: PropTypes.bool,
	tabindex: PropTypes.number,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onKeyDown: PropTypes.func,
	autoComplete: PropTypes.string
};

export default TextBox;
export {styles as textBoxStyles};